module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("5vWgD"))).then(() => parcelRequire('ec1PW'));